<div class="alert" [ngClass]="{ 'alert-success': messageType === 'success', 'alert-danger': messageType === 'error' }">
    {{ message }}
    <mat-icon (click)="closeMessage()">close</mat-icon>
</div>
